module.exports = __webpack_public_path__ + "img/kommune-1412.ffca95ee.svg";